__turbopack_context__.v({
  "arrow": "technologies-showcase-arrow-module__xSjrBq__arrow",
  "icon": "technologies-showcase-arrow-module__xSjrBq__icon",
});
